import { AfterViewInit, Directive, ElementRef, HostListener, Input, OnChanges, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { NgControl } from '@angular/forms';
import { DisabledHelper } from 'helpers/disabled-helper';

declare let $: any;
declare let document: any;
let global_reset_binding: boolean = false;

@Directive({
  selector: '[validationNoControl]'
})
export class ValidationNoControlDirective implements OnInit, AfterViewInit, OnChanges {
  @Input() validation: boolean;
  @Input() validationActive: boolean;
  @Input() validationMessage: string;
  @Input() validationElement: string;
  errorMessage: any = {
    email: "กรุณาใส่อีเมลให้ถูกต้อง",
    thai: "กรุณาใส่ข้อมูลให้ถูกต้อง",
    number: "กรุณาใส่ตัวเลขให้ถูกต้อง",
    phoneNumber: "กรุณาใส่หมายเลขโทรศัพท์ให้ถูกต้อง",
    date: "กรุณาเลือกวันที่ให้ถูกต้อง",
    dateTime: "กรุณาเลือกวันที่และเวลาให้ถูกต้อง",
    hour: "กรุณาเลือกเวลาให้ถูกต้อง",
    select: "กรุณาเลือกข้อมูล",
    price: "กรุณาใส่ราคาให้ถูกต้อง",
    province: "กรุณาเลือกจังหวัดให้ถูกต้อง",
    title: "กรุณาเลือกคำนำหน้าชื่อ",
    status: "กรุณาเลือกสถานะ",
  };
  checkFormInputValidateDelegate: any;
  resetFormInputValidateDelegate: any;

  constructor(private el: ElementRef,
              private renderer: Renderer2,
              private control : NgControl) {
  }

  latestValidValue: string = "";
  latestFlexibleValue: string = "";

  ngOnInit (): any {
    this.checkFormInputValidateDelegate = this.checkFormInputValidate.bind(this);
    this.resetFormInputValidateDelegate = this.resetFormInputValidate.bind(this);

    $(document).bind('checkFormInputsValidation', this.checkFormInputValidateDelegate);
    $(document).bind('resetFormInputsValidation', this.resetFormInputValidateDelegate);

    if (!global_reset_binding) {
      $(document).bind('shown.bs.modal', () => {
        $(document).trigger('resetFormInputsValidation', {'type': 'shown'});
      });
      $(document).bind('hide.bs.modal', () => {
        $(document).trigger('resetFormInputsValidation', {'type': 'hide'});
      });
      global_reset_binding = true;
    }

    this.resetFormInputValidate(null, null);
  }

  ngOnDestroy (): any {
    $(document).unbind('checkFormInputsValidation', this.checkFormInputValidateDelegate);
    $(document).unbind('resetFormInputsValidation', this.resetFormInputValidateDelegate);

    this.latestValidValue = "";
    this.latestFlexibleValue = "";
  }

  ngAfterViewInit() {
  }

  @HostListener('input',['$event'])
  @HostListener('paste',['$event'])
  onEvent(event) {
    let element = $(this.el.nativeElement);
    let pattern = this.getValidationPattern(true);
    let value = element.val() || "";
    if (!value.match(pattern)) element.val(value.trim());

    this.ngOnChanges();
  }

  @HostListener('keyup', ["$event"])
  onChanges(event) {
    this.ngOnChanges();

    let element = $(this.el.nativeElement);
    let val = element.val() || '';
    let pattern = this.getValidationPattern(true);
    if (!pattern) return;

    // This condition is to prevent selection and keyboard navigation issues
    //
    // if (!val.match(pattern)) {
    //   let index = this.getCursorPosition(element);
    //   this.el.nativeElement.value = this.latestFlexibleValue;
    //   this.control.control.setValue(this.latestFlexibleValue);
    //
    //   $(document).trigger('checkFormInputsValidation', {'type': 'shown'});
    //
    //   let length = val.length - this.latestFlexibleValue.length;
    //   this.setCursorPosition(element, index-length, index-length);
    // } else {
    //   this.latestFlexibleValue = val;
    // }
  }

  ngOnChanges() {
    this.removeError('custom-error');
    if (this.validationActive) {
      if (!this.checkValidate()) {
        this.addError('custom-error');
      }
    }
  }

  checkFormInputValidate(event, results) {
    setTimeout(()=>{
      this.removeError('custom-error');
      this.ngOnChanges();
    }, 100);

    if (results) {
      results.areFormInputsValid = results.areFormInputsValid && this.checkValidate();
    }
  }

  resetFormInputValidate(event: any, results: any) {
    let typeOfReset = results ? results['type'] : 'shown';
    this.removeError('custom-error');

    if (typeOfReset === 'shown') {
      let element = $(this.el.nativeElement);
      let val = element.val() || "";
      let pattern = this.getValidationPattern(true);
      if (!pattern) return;

      if (val.match(pattern)) {
        this.latestValidValue = val;
        this.latestFlexibleValue = val;
      } else {
        this.latestValidValue = "";
        this.latestFlexibleValue = "";
      }
    }
  }

  checkValidate() {
    const element = this.el.nativeElement;
    if (DisabledHelper.hasDisablingState(element) || element.disabled) return true;

    let pattern = this.getValidationPattern(false);
    let val = element.value;
    let tagName = element.tagName;
    let isCanEmpty: boolean = !element.attributes.required;

    // TODO: need refactoring
    //
    if (val) {
      if (this.validation === false) {
        return false;
      } else if (tagName === 'INPUT' && !val.match(pattern)) {
        return false;
      } else {
        return true;
      }
    } else {
      if (isCanEmpty) {
        if (this.validation === false) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    }
  }

  getValidationPattern(flexible: boolean) {
    let element = $(this.el.nativeElement);
    let pattern = element.attr((flexible) ? 'validation-flexible-pattern' : 'validation-validate-pattern');
    if (pattern && pattern[0] == "~") {
      pattern = element.attr(pattern.replace(/[\~\[\]]/g, ''));
    }
    if (!pattern) return false;
    pattern = pattern.replace("&#34;", "\"");
    return new RegExp(pattern);
  }

  // Get cursor position code from:
  // https://stackoverflow.com/questions/2897155/get-cursor-position-in-characters-within-a-text-input-field
  //
  getCursorPosition(element) {
    let input = element.get(0);
    if (!input) return; // No (input) element found
    if ('selectionStart' in input) {
      // Standard-compliant browsers
      return input.selectionStart;
    } else if (document.selection) {
      // IE
      input.focus();
      let sel = document.selection.createRange();
      let selLen = document.selection.createRange().text.length;
      sel.moveStart('character', -input.value.length);
      return sel.text.length - selLen;
    }
  }

  // Set cursor position code from:
  // https://stackoverflow.com/questions/499126/jquery-set-cursor-position-in-text-area/499158#499158
  //
  setCursorPosition(element, start, end) {
    if (end === undefined) {
      end = start;
    }
    return element.each(function() {
      if ('selectionStart' in this) {
        this.selectionStart = start;
        this.selectionEnd = end;
      } else if(this.setSelectionRange) {
        this.setSelectionRange(start, end);
      } else if(this.createTextRange) {
        let range = this.createTextRange();
        range.collapse(true);
        range.moveEnd('character', end);
        range.moveStart('character', start);
        range.select();
      }
    });
  }

  addError(className: string) {

    let message = this.validationMessage || "&nbsp;";
    if (this.validationMessage.indexOf('~') == 0) {
      message = this.errorMessage[message.replace(/^\~/, '')];
    }

    if (this.el.nativeElement.parentNode.className.indexOf('input-group') != -1) {
      this.el.nativeElement.parentNode.insertAdjacentHTML('afterend',
        '<div class="custom-error-message">' +
          message +
        '</div>'
      );
      this.renderer.addClass(this.el.nativeElement, className);
    }
    else if (message && this.validationElement) {
      $(this.validationElement)[0].insertAdjacentHTML('afterend',
        '<div class="custom-error-message">' +
          message +
        '</div>'
      );
      $(this.validationElement).addClass(className);
    }
    else if (message && (!this.el.nativeElement.nextSibling || !this.el.nativeElement.nextSibling.className ||
      this.el.nativeElement.nextSibling.className.indexOf('custom-error-message') == -1)) {
      this.el.nativeElement.insertAdjacentHTML('afterend',
        '<div class="custom-error-message">' +
          message +
        '</div>'
      );
      this.renderer.addClass(this.el.nativeElement, className);
    }
  }

  removeError(className: string) {
    if (this.el.nativeElement.parentNode.className.indexOf('input-group') != -1 &&
        this.el.nativeElement.parentNode.nextSibling && this.el.nativeElement.parentNode.nextSibling.className &&
        this.el.nativeElement.parentNode.nextSibling.className.indexOf('custom-error-message') != -1) {
      this.el.nativeElement.parentNode.nextSibling.remove();
      this.renderer.removeClass(this.el.nativeElement, className);
    }
    else if (this.validationElement) {
      let element = $(this.validationElement)[0];
      if (element.nextSibling && element.nextSibling.className &&
          element.nextSibling.className.indexOf('custom-error-message') != -1) element.nextSibling.remove();
      $(this.validationElement).removeClass(className);
    }
    else if (this.el.nativeElement.nextSibling && this.el.nativeElement.nextSibling.className &&
             this.el.nativeElement.nextSibling.className.indexOf('custom-error-message') != -1) {
      this.el.nativeElement.nextSibling.remove();
      this.renderer.removeClass(this.el.nativeElement, className);
    } else {
      this.renderer.removeClass(this.el.nativeElement, className);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/helpers/directives/validation/validationNoControl.directive.ts